import { Icon } from '../c-mp/comp/Icon'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { onLinkClickFocusSearchInput } from '../fun/onLinkClickFocusSearchInput'
import { ICON_EMAIL } from '../icon/ICON_EMAIL'
import { ICON_MARRIED } from '../icon/ICON_MARRIED'
import { ICON_SEARCH } from '../icon/ICON_SEARCH'
import { appState } from '../model/appState'
import { _ } from '../model/ccc'
import { Page } from '../model/Page'

export const MenuComp = defineComponent<{ logOut: () => void }>(
	'MenuComp',
	({ logOut }, $) => {
		return (
			<>
				<a
					class={_.ccc_button__rounded}
					inert={() => appState.page === Page.Quiz}
					href='/quiz'
				>
					❓Kvíz
				</a>
				<a
					class={_.ccc_button__rounded}
					inert={() => appState.page === Page.Birthdays}
					href={`/birthdays`}
				>
					🎂 Születésnapok
				</a>
				<a
					class={_.ccc_button__rounded}
					inert={() => appState.page === Page.WeddingAnniversaries}
					href={`/wedding-anniversaries`}
				>
					<Icon svg={ICON_MARRIED} /> Házassági évfordulók
				</a>
				<a
					class={_.ccc_button__rounded}
					inert={() => appState.page === Page.Emails}
					href={`/emails`}
				>
					<Icon svg={ICON_EMAIL} />
					Email címek
				</a>
				<hr />
				<a
					class={_.ccc_button}
					href='/search'
					onclick={onLinkClickFocusSearchInput}
				>
					<Icon svg={ICON_SEARCH} /> Kereső
				</a>
				<a class={_.ccc_button__rounded} href='/search?query=Parditka%20%2B'>
					Minden elhunyt Parditka
				</a>
				<a class={_.ccc_button__rounded} href={`/search?query=%2B`}>
					Minden elhunyt
				</a>
				<a class={_.ccc_button__rounded} href={`/search?query=%3A)`}>
					Mindenki élő
				</a>
				<hr />
				<a
					class={_.ccc_button__rounded}
					inert={() => appState.page === Page.RelativesAlive}
					href='/relatives-alive'
				>
					Élő <b>rokonok</b>
				</a>
				<a
					class={_.ccc_button__rounded}
					inert={() => appState.page === Page.Parentless}
					href='/parentless'
				>
					Ősök
				</a>
				<a
					class={_.ccc_button__rounded}
					inert={() => appState.page === Page.Clouds}
					href='/clouds'
				>
					Felhők
				</a>
				<a
					class={_.ccc_button__rounded}
					inert={() => appState.page === Page.AverageAge}
					href={`/average-age`}
				>
					Átlagos életkor
				</a>
				<hr />
				<button class={_.ccc_button} onclick={logOut}>
					<Icon svg='<svg class="ccc_icon" viewBox="0 0 16 16"><g fill="currentColor" fill-rule="evenodd"><path d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/><path d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/></g></svg>' />{' '}
					Kilépek
				</button>
			</>
		)
	},
)
